// Contract merge tokens — used in agreement template bodies.
// Mirrors the structure of src/data/emailTemplates.js EMAIL_VARIABLES.
//
// Token syntax: {{token_name}} — substituted at render time by renderContract().

export const CONTRACT_TOKEN_GROUPS = [
  {
    id: 'lessee',
    label: 'Lessee / Customer',
    tokens: [
      { token: '{{lessee_name}}',     label: 'Full name' },
      { token: '{{lessee_company}}',  label: 'Company name (if any)' },
      { token: '{{lessee_address}}',  label: 'Address' },
      { token: '{{lessee_passport}}', label: 'ID / Passport number' },
      { token: '{{lessee_licence}}',  label: 'Driving licence number' },
      { token: '{{lessee_licence_expiry}}', label: 'Licence expiry' },
      { token: '{{lessee_email}}',    label: 'Email' },
      { token: '{{lessee_phone}}',    label: 'Phone' },
      { token: '{{lessee_vat}}',      label: 'VAT number (companies)' },
      { token: '{{lessee_nationality}}', label: 'Nationality' },
      { token: '{{lessee_dob}}',      label: 'Date of birth' },
    ],
  },
  {
    id: 'vehicle',
    label: 'Vehicle',
    tokens: [
      { token: '{{vehicle_name}}',    label: 'Make / model name' },
      { token: '{{vehicle_plate}}',   label: 'Plate number' },
      { token: '{{vehicle_year}}',    label: 'Year' },
      { token: '{{vehicle_vin}}',     label: 'VIN / chassis number' },
      { token: '{{vehicle_colour}}',  label: 'Colour' },
      { token: '{{vehicle_mileage}}', label: 'Mileage at handover' },
      { token: '{{vehicle_fuel}}',    label: 'Fuel type' },
      { token: '{{vehicle_transmission}}', label: 'Transmission' },
    ],
  },
  {
    id: 'rental',
    label: 'Rental / Lease',
    tokens: [
      { token: '{{contract_id}}',         label: 'Contract number' },
      { token: '{{start_date}}',          label: 'Start / pickup date' },
      { token: '{{end_date}}',            label: 'End / return date' },
      { token: '{{start_time}}',          label: 'Start time' },
      { token: '{{end_time}}',            label: 'End time' },
      { token: '{{pickup_location}}',     label: 'Pickup location' },
      { token: '{{return_location}}',     label: 'Return location' },
      { token: '{{term_months}}',         label: 'Lease term (months)' },
      { token: '{{duration_days}}',       label: 'Duration (days)' },
      { token: '{{monthly_rate}}',        label: 'Monthly rate' },
      { token: '{{daily_rate}}',          label: 'Daily rate' },
      { token: '{{annual_mileage_cap}}',  label: 'Annual mileage cap' },
      { token: '{{deposit}}',             label: 'Deposit amount' },
      { token: '{{deposit_method}}',      label: 'Deposit method' },
      { token: '{{total_contract}}',      label: 'Total contract value' },
      { token: '{{included_services}}',   label: 'Included services' },
      { token: '{{insurance_name}}',      label: 'Insurance plan' },
      { token: '{{insurance_excess}}',    label: 'Insurance excess' },
      { token: '{{extras}}',              label: 'Selected extras' },
    ],
  },
  {
    id: 'lessor',
    label: 'Lessor / Company',
    tokens: [
      { token: '{{lessor_name}}',    label: 'Company name' },
      { token: '{{lessor_address}}', label: 'Company address' },
      { token: '{{lessor_phone}}',   label: 'Company phone' },
      { token: '{{lessor_email}}',   label: 'Company email' },
      { token: '{{lessor_vat}}',     label: 'Company VAT number' },
      { token: '{{lessor_regnum}}',  label: 'Company registration #' },
      { token: '{{lessor_logo}}',    label: 'Company logo (image)' },
    ],
  },
  {
    id: 'signature',
    label: 'Signature & dates',
    tokens: [
      { token: '{{signature}}',    label: 'Customer signature (image)' },
      { token: '{{signed_date}}',  label: 'Signed-on date / time' },
      { token: '{{today}}',        label: 'Today’s date' },
    ],
  },
];

// Flat list, useful for the renderer / validation
export const CONTRACT_TOKENS = CONTRACT_TOKEN_GROUPS.flatMap(g => g.tokens.map(t => t.token));
